import React from "react";
import styled from "styled-components";
import Button from "../Button";
import { ReactSVG } from "react-svg";
import { getAuth, signInWithPopup, GoogleAuthProvider } from "firebase/auth";
import userModel from "../../lib/firebase/userModel";
import { useNavigate, useSearchParams } from "react-router-dom";
import { authRoutes } from "../../helpers/authentication";
import { DIALOG_NAME } from "../../helpers/useDialogSearchParam";
import { getPostLoginHomePath } from "../../helpers/accountProduct";

const auth = getAuth();
const provider = new GoogleAuthProvider();

const ICON_GOOGLE = "/icons/google.svg";

export default function ThirdPartyAuth({
  cta = "log in",
  size = "large",
  onCompletion,
}) {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  const openGoogleAuth = () => {
    signInWithPopup(auth, provider)
      .then(async (result) => {
        const user = result.user;
        const userInfo = await userModel.getOneById(user.uid);
        const currentLocation = window.location.pathname;
        if (user && !userInfo) {
          // Ideally we wouldn't redirect if they are already on the signup page or in the signup modal
          if (
            !authRoutes.includes(currentLocation) &&
            searchParams.get(DIALOG_NAME.signup) === null
          ) {
            return navigate("/signup");
          }
        } else {
          // User exists and logged in successfully
          // Set firstLoginAt timestamp if this is the user's first login
          if (userInfo && !userInfo.firstLoginAt) {
            try {
              await userModel.update({
                id: user.uid,
                data: {
                  firstLoginAt: new Date().toISOString(),
                },
              });
              console.log(
                "[ThirdPartyAuth] Set firstLoginAt timestamp for user:",
                user.uid
              );
            } catch (error) {
              console.error(
                "[ThirdPartyAuth] Error setting firstLoginAt:",
                error
              );
              // Don't fail login if this update fails
            }
          }

          if (!authRoutes.includes(currentLocation)) {
            searchParams.delete(DIALOG_NAME.login);
            setSearchParams(searchParams);
            navigate(getPostLoginHomePath(userInfo));
          } else {
            navigate(getPostLoginHomePath(userInfo));
          }
        }
        onCompletion?.();
      })
      .catch((error) => {
        console.error(error);
      });
  };

  return (
    <>
      <StyledButton
        variant="ghost"
        size={size}
        onClick={() => openGoogleAuth()}
      >
        <Logo src={ICON_GOOGLE} />
        <Cta>{cta}</Cta> with Google
      </StyledButton>
    </>
  );
}

const Cta = styled.div`
  text-transform: capitalize;
  margin-right: 4px;
`;

const Logo = styled(ReactSVG)`
  position: absolute;
  left: 12px;
`;

const StyledButton = styled(Button)`
  color: black;
`;
